import { createContext, useContext } from "react";

export const SectionRefsContext = createContext(null);

export const useSectionRefs = () => useContext(SectionRefsContext);